import React, {Component} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import {Link} from 'react-router-dom';
import {
    Grid, Popper, Grow, Paper, ClickAwayListener,
    MenuList, MenuItem, Hidden
} from '@material-ui/core';

import urls from "../../../utils/urls";
import Select from "./select";
import {
    fetchAreas, fetchZones, fetchStations, selectArea, selectZone, selectStation
} from "../../../actions/navigation_actions";
import ProfileImage from "../../../components/profileImage/ProfileImage";
import './styles.scss';


class Header extends Component {

    constructor(props) {
        super(props);

        this.state = {
            toolsOpen: false,
            profileOpen: false,
            selectedArea: -1,
            selectedZone: -1,
            selectedStation: -1,
            disableZoneSelect: true,
            disableStationSelect: true
        };
    };


    onAreaValueChange = (ev) => {
        this.props.selectArea(ev.target.value);
        this.props.selectZone(-1);
        this.props.selectStation(-1);
        this.setState({
            disableZoneSelect: false,
            disableStationSelect: true
        })
    };

    onZoneValueChange = (ev) => {
        this.props.selectZone(ev.target.value);
        this.props.selectStation(-1);
        this.setState({
            disableStationSelect: false
        })
    };

    onStationValueChange = (ev) => {
        console.log(ev.target.value);
        this.props.selectStation(ev.target.value);
    };

    _handleToggleProfile = () => {
        this.setState({profileOpen: !this.state.profileOpen});
    };

    _handleToggleTools = () => {
        this.setState({toolsOpen: !this.state.toolsOpen});
    };

    componentWillReceiveProps(nextProps) {
        let {stations, areas, zones} = nextProps;

        if (areas.list && nextProps.navigation.areas.length === 0) {
            this.props.fetchAreas(areas.list);
        }
        let navigation = this.props.navigation;
        let next = nextProps.navigation;

        if (navigation && navigation.selectedArea !== next.selectedArea) {
            this.props.fetchZones(zones.list, next.selectedArea);
        }
        if (navigation && navigation.selectedZone !== next.selectedZone) {
            this.props.fetchStations(stations.list, next.selectedZone);
        }

    }

    render() {
        let pathname = window.location.pathname;
        let showNavigation = pathname === '/dashboard-slp';

        let {user} = this.props;
        const {toolsOpen, profileOpen} = this.state;

        let tools = [];
        if (user && user.profile && user.profile.cas_permissions) {
            tools = JSON.parse(
                user.profile.cas_permissions.replace(/'/g, '"')
                    .replace(/True/g, true).replace(/False/g, false)
            );
        }

        return (
            <div className={'main-header'}>
                {user &&
                <Grid container className={'main-div'} spacing={0}>
                    <Grid item xs={12} sm={2} className={"header-main"}>
                        <div className={"subtitle"}>SHELL RETAIL ARGENTINA</div>
                        <div className={"title-header"}>{this.props.title}</div>
                    </Grid>
                    <Grid item xs={12} sm={7}>
                        {this.props.navigation.areas.length>=1 && showNavigation &&
                        <div className={"navigation"}>
                            <Select label={"Area"} className={"select"}
                                    selectedValue={this.props.navigation.selectedArea}
                                    values={this.props.navigation.areas}
                                    onValueChange={this.onAreaValueChange} defaultValue={"Todas"}/>
                            <Select label={"Zonas"} className={"select"} values={this.props.navigation.zones}
                                    onValueChange={this.onZoneValueChange} disabled={this.state.disableZoneSelect}
                                    selectedValue={this.props.navigation.selectedZone}
                                    defaultValue={"Seleccione"}/>
                            <Select label={"Bocas"} className={"select"} disabled={this.state.disableStationSelect}
                                    selectedValue={this.props.navigation.selectedStation}
                                    values={this.props.navigation.stations}
                                    onValueChange={this.onStationValueChange} defaultValue={"Seleccione"}/>
                        </div>}
                    </Grid>
                    <Hidden xsDown>
                        <Grid item xs={3} className={'text-right'}>
                            <div className={"tools"}>
                                <div className={"tools-button"}
                                     ref={node => {
                                         this.anchorTools = node;
                                     }}
                                     aria-owns={profileOpen ? 'menu-list-grow' : null}
                                     aria-haspopup="true"
                                     onClick={this._handleToggleTools}
                                >
                                    <i className="material-icons">apps</i>
                                </div>
                                <Popper open={toolsOpen} anchorEl={this.anchorTools} transition disablePortal>
                                    {({TransitionProps}) => {
                                        return (
                                            <Grow
                                                {...TransitionProps}
                                                id="tools-list-grow"
                                                style={{transformOrigin: 'bottom', marginRight: 120}}
                                            >
                                                <Paper className={'squared-borders'}>
                                                    <ClickAwayListener onClickAway={this._handleToggleTools}>
                                                        <MenuList className={'apps-ul-container'}>
                                                            <MenuItem className={'apps-li-container'}>
                                                                <div className={'apps-container'}>
                                                                    {tools.map((tool, i) => {
                                                                        return (
                                                                            <div className="app-container" key={i}>
                                                                                <a href={tool.url} target="_blank">
                                                                                    <img src={tool.logo}
                                                                                         alt={tool.name}/>
                                                                                    <p>{tool.name}</p>
                                                                                </a>
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </MenuItem>
                                                        </MenuList>
                                                    </ClickAwayListener>
                                                </Paper>
                                            </Grow>
                                        )
                                    }}
                                </Popper>
                            </div>
                            <div className={"user"}>
                                <ProfileImage user={user}/>
                                <div className={"username"}
                                     ref={node => {
                                         this.anchorProfile = node;
                                     }}
                                     aria-owns={profileOpen ? 'menu-list-grow' : null}
                                     aria-haspopup="true"
                                     onClick={this._handleToggleProfile}
                                >
                                    <div className={'username-container name'}>
                                        <div>{user.first_name}</div>
                                        <div>{user.last_name}</div>
                                    </div>
                                </div>
                                <Popper open={profileOpen} anchorEl={this.anchorProfile} transition disablePortal>
                                    {({TransitionProps, placement}) => {
                                        return (
                                            <Grow
                                                {...TransitionProps}
                                                id="menu-list-grow"
                                                style={{transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'}}
                                            >
                                                <Paper className={'squared-borders'}>
                                                    <ClickAwayListener onClickAway={this._handleToggleProfile}>
                                                        <MenuList className={'user-ul-container'}>
                                                            <MenuItem>
                                                                <a href={urls.SSO_URL} target={"_blank"}>Ir a perfil</a>
                                                            </MenuItem>
                                                            <MenuItem>
                                                                <Link to={`${urls.API_ROOT}/logout`}>Terminar
                                                                    sesión</Link>
                                                            </MenuItem>
                                                        </MenuList>
                                                    </ClickAwayListener>
                                                </Paper>
                                            </Grow>
                                        )
                                    }}
                                </Popper>
                            </div>
                        </Grid>
                    </Hidden>
                </Grid>
                }
            </div>
        );
    }
}

Header.defaultProps = {
    title: ''
};


const mapStateToProps = (state) => {
    return {
        user: state.user,
        stations: state.stations,
        areas: state.areas,
        zones: state.zones,
        navigation: state.navigation
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({fetchAreas, fetchZones, fetchStations, selectArea, selectZone, selectStation}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);


// WEBPACK FOOTER //
// ./src/containers/general/header/Header.js